module.exports = "https://cdn.hellotech.com/client-assets/logo_verge_5f478b141553739d6cac97b18097bb6e.png";